


import { defineComponent } from '@vue/composition-api';
import SettouReportCommon from '@/components/Sp/Johaisetsu/SettouPatrol/SettouReportCommon/index.vue';
import CreateSettouPatrolReport from '@/components/Sp/Johaisetsu/SettouPatrol/SettouPatrol/CreateSettouPatrolReport/index.vue';
import johaisetsuSettouPatrolApi from '@/apis/johaisetsu/settouPatrol/settouPatrol/johaisetsu_settou_patrol';
import { JohaisetsuSettouPatrolDetailApi } from '@/components/Sp/Johaisetsu/types';
import {
  updateJohaisetsuStart,
  updateJohaisetsuEnd,
  updateBaseArrival,
} from '@/lib/johaisetsu/settouPatrol/settouPatrol/johaisetsuSettouPatrolUtil';

export default defineComponent({
  setup() {
    const detailApis: JohaisetsuSettouPatrolDetailApi = {
      create: johaisetsuSettouPatrolApi.create,
      update: johaisetsuSettouPatrolApi.update,
      getCurrent: johaisetsuSettouPatrolApi.getCurrent,
      updateJohaisetsuStart: updateJohaisetsuStart,
      updateJohaisetsuEnd: updateJohaisetsuEnd,
      updateBaseArrival: updateBaseArrival,
    };

    return {
      detailApis,
      createReportComponent: CreateSettouPatrolReport,
    };
  },
  components: { SettouReportCommon },
});
